var map = {
	"./en/translation.json": [
		19365,
		9365
	],
	"./hy/translation.json": [
		80745,
		745
	],
	"./me/translation.json": [
		60648,
		648
	],
	"./pl/translation.json": [
		51834,
		1834
	],
	"./ru/translation.json": [
		12375,
		2375
	],
	"./sr/translation.json": [
		15768,
		3387
	],
	"./ua/translation.json": [
		92060,
		2060
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78563;
module.exports = webpackAsyncContext;